var $ = jQuery.noConflict();

jQuery.extend(jQuery.fn.dataTableExt.oSort, {
    "book-title-pre": function (a) {
        a = a.replace(/<a\s+(?:[^>]*?\s+)?href="([^"]*)">/i, "");
        a = a.replace(/^(a |an |the |‘)/i, "");
        return a;
    }
});

var RGC = {
    // All pages
    common: {
        init: function () {
            this.initOutOfStockProducts();
            this.initSelectOptionsText();
            this.wrapSelectElements();
            this.initAJAXPostLoading();
            this.initMobileMenu();
            this.initSocialSharing();
            this.initEventTracking();
            this.initDataTables();
        },
        initOutOfStockProducts: function () {
            $('.outofstock img').attr('src', '/wp/wp-content/uploads/2016/08/outofstock-170x224.png');
            $('.outofstock img').attr('srcset', '/wp/wp-content/uploads/2016/08/outofstock-170x224.png 170w, /wp/wp-content/uploads/2016/08/outofstock-228x300.png 228w, /wp/wp-content/uploads/2016/08/outofstock.png 455w');

            $(".outofstock a > img").unwrap();
            $(".outofstock a").each(function () {
                stockWrap = $(this).html();
                $(stockWrap).insertAfter($(this))
                $(this).remove()
            });
        },
        initSelectOptionsText: function () {
            $('.variations select[name=attribute_pa_format] > option:first-child').text('Choose a Format');
        },
        initMobileMenu: function () {
            var mobileMenu = $('select.mobile-navigation');
            mobileMenu.on('change', function () {
                window.location.href = $(this).val();
            });
        },

        initDataTables: function () {
            if ($('#book-search-table').length) {

                var old_start = 0;
                var book_table = $('#book-search-table').DataTable({
                    columnDefs: [
                        { type: 'book-title', targets: 0 }
                    ],
                    pageLength: 50,
                    lengthChange: false,
                    // responsive: true,
                    language: {
                        "search": "Search Books:"
                    },
                    drawCallback: function (o) {
                        var new_start = this.api().page.info().start;

                        if (new_start != old_start) {
                            var targetOffset = $('#book-search-table').offset().top;
                            $('html,body').animate({ scrollTop: targetOffset }, 250);
                            old_start = new_start;
                        }
                    },
                    initComplete: function (settings, json) {
                        setTimeout(function () {
                            console.log('secondary call...');
                            $('#book-search-author').change();

                            $('.datatable-loading').fadeOut('fast');
                            $('#book-search-table').fadeIn('fast');
                        }, 5); //need just a slight delay here so the event actually fires...
                    }
                });

                // Title
                $('#book-search-title').on('keyup change', function () {
                    var col = book_table.column(0);

                    if (col.search() !== this.value) {
                        col
                            .search(this.value)
                            .draw();
                    }
                });

                if ($('#book-search-title').val()) {
                    var searchValue = $('#book-search-title').val();
                    //console.log('title has a value ' + searchValue);
                    var col = book_table.column(0);
                    col
                        .search(searchValue)
                        .draw();
                }

                // Author
                $('#book-search-author').on('keyup change', function () {
                    var col = book_table.column(1);

                    if (col.search() !== this.value) {
                        col
                            .search(this.value)
                            .draw();
                    }

                });

                if ($('#book-search-author').val()) {
                    var searchValue = $('#book-search-author').val();
                    //console.log('author has a value ' + searchValue);
                    var col = book_table.column(1);
                    col
                        .search(searchValue)
                        .draw();
                }

                // Genre
                $('#book-search-genre').on('change', function () {
                    var col = book_table.column(2);
                    var val = $.fn.dataTable.util.escapeRegex(
                        $(this).val()
                    );
                    col
                        .search((val) ? '^' + val + '$' : '', true, false)
                        .draw();
                });

                if ($('#book-search-genre').val()) {
                    var searchValue = $('#book-search-genre').val();
                    //console.log('genre has a value ' + searchValue);
                    var col = book_table.column(2);
                    var val = $.fn.dataTable.util.escapeRegex(
                        searchValue
                    );
                    col
                        .search((val) ? '^' + val + '$' : '', true, false)
                        .draw();
                }

                // Subject
                $('#book-search-subject').on('keyup change', function () {
                    var col = book_table.column(3);
                    if (col.search() !== this.value) {
                        col
                            .search(this.value)
                            .draw();
                    }
                });

                if ($('#book-search-subject').val()) {
                    var searchValue = $('#book-search-subject').val();
                    //console.log('subject has a value ' + searchValue);
                    var col = book_table.column(3);
                    col
                        .search(searchValue)
                        .draw();

                }

                // Years
                $('#book-search-years').on('keyup change', function () {
                    var col = book_table.column(4);
                    if (col.search() !== this.value) {
                        col
                            .search(this.value)
                            .draw();
                    }
                });

                if ($('#book-search-years').val()) {
                    var searchValue = $('#book-search-years').val();
                    //console.log('years has a value ' + searchValue);
                    var col = book_table.column(4);
                    col
                        .search(searchValue)
                        .draw();

                }
                // Editions
                $('#book-search-editions').on('keyup change', function () {
                    var col = book_table.column(5);
                    if (col.search() !== this.value) {
                        col
                            .search(this.value)
                            .draw();
                    }
                });

                if ($('#book-search-editions').val()) {
                    var searchValue = $('#book-search-editions').val();
                    //console.log('editions has a value ' + searchValue);
                    var col = book_table.column(5);
                    col
                        .search(searchValue)
                        .draw();

                }


            }
        },
        initAJAXPostLoading: function () {
            // AJAX post loading on blog
            var postsContainer = $('.blog_additional-posts');
            var loadMorePostsButton = $('.load-more-posts');

            loadMorePostsButton.on('click', function () {
                var $this = $(this);
                var pageToLoad = $this.data('next-page');
                var data = {
                    action: 'rgc_get_more_posts',
                    query_vars: ajaxInfo.query_vars,
                    page: pageToLoad

                }
                $.ajax({
                    url: ajaxInfo.ajaxUrl,
                    type: 'POST',
                    data: data,
                    dataType: "HTML",
                    success: function (response) {
                        var jsonResponse = JSON && JSON.parse(response) || $.parseJSON(response);
                        //console.log(jsonResponse);
                        postsContainer.append(jsonResponse.html);

                        if (jsonResponse.more_posts == 0) {
                            $('.blog_load-more-posts-footer').fadeOut();
                        } else {
                            loadMorePostsButton.data('next-page', parseInt(pageToLoad, 10) + 1);
                        }
                    },
                    error: function (response) {

                    }
                });
            });
        },
        wrapSelectElements: function () {
            $('select').wrap('<span class="select-wrapper"></span>');
        },
        initSocialSharing: function () {
            $('.widget_social-sharing a').click(function (e) {

                var id = $(this).data("windowid");
                if (id == null || id.closed) {
                    id = window.open($(this).attr("href"), '_blank', 'modal=yes, width=500, height=250');
                }
                id.focus();
                $(this).data("windowid", id);
                e.preventDefault();
                return false;
            });
        },
        initEventTracking: function () {
            // Event Tracking - Books
            $('.featured-book .title a').click(function () {
                var bookName = $(this).attr('title');
                //ga('send', 'event', 'Book', 'Click', bookName);
                console.log(bookName);
            });

            // Event Tracking - Add Block
            $('.ad-block').click(function () {
                var adBlock = $(this).attr('title');
                //ga('send', 'event', 'Ad Block', 'Click', adBlock);
                console.log(adBlock);
            });
        },
    },
    page_template_template_featured_books: {

        init: function () {
            this.initBookPopovers();
        },
        initBookPopovers: function () {
            $('[data-toggle="popover"]').popover({
                trigger: 'hover'
            });
        }
    },
    single_book: {
        init: function () {
            this.initReadMore();
            this.initFirstTabSelection();
            this.initAdaptiveBgColors();
            this.initDiscussionsCheck();
        },
        initReadMore: function () {
            var readMoreTrigger = $('.show-full-book-description');
            var readLessTrigger = $('.hide-full-book-description');
            var bookExcerpt = $('#book_excerpt');
            var bookDescription = $('#book_description_full');

            readMoreTrigger.on('click', function (e) {
                e.preventDefault();
                bookExcerpt.slideUp(50, function () {
                    bookDescription.slideDown();
                });
            });

            readLessTrigger.on('click', function (e) {
                e.preventDefault();
                bookDescription.slideUp(50, function () {
                    bookExcerpt.slideDown();
                });
            });
        },
        initFirstTabSelection: function () {
            $('.nav-tabs li:first-child a').tab('show');
        },
        initAdaptiveBgColors: function () {
            $.adaptiveBackground.run();
        },
        initDiscussionsCheck: function () {
            if (window.location.hash === "#discussion_questions") {
                $('li.discussions a').tab('show');
                $('html, body').animate({
                    scrollTop: ($('.nav-tabs').offset().top)
                }, 500);
            }
        }
    },
    woocommerce_account: {
        init: function () {
            //this.initRegistrationCaptchaCheck();
        },
        initRegistrationCaptchaCheck: function () {
            var form = $('form.register');
            form.submit(function () {
                return grecaptcha.getResponse() !== "";
            });
        }
    },

};

UTIL = {

    fire: function (func, funcname, args) {

        var namespace = RGC;  // indicate your obj literal namespace here

        funcname = (funcname === undefined) ? 'init' : funcname;
        if (func !== '' && namespace[func] && typeof namespace[func][funcname] == 'function') {
            namespace[func][funcname](args);
        }

    },

    loadEvents: function ($) {

        var bodyId = document.body.id;

        // hit up common first.
        UTIL.fire('common');

        // do all the classes too.
        $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
            UTIL.fire(classnm);
            UTIL.fire(classnm, bodyId);
        });

    }
};

$(document).ready(UTIL.loadEvents);

// force a cart update when qtys change
const preventClass = 'must-update-cart';
$('body')
    .on('updated_wc_div', function () {
        $('body').removeClass(preventClass);
        $('#updateCart').removeAttr('style');
    })
    .on('change', '.qty', function () {
        $('body').addClass(preventClass);
    })
    .on('click', '.plus, .minus', function () {
        $('body').addClass(preventClass);
    })
    .on('click', '#updateCart', function (e) {
        e.preventDefault();
        $(this).css('opacity', '.4')
        $('[name="update_cart"]').click(); // default one is hidden because it's in a weird location
    });